<template>
  <div>
    <el-aside class="subnav" style="background-color:#f7f8fa">
      <div class="subNav_Title">
        <h3>用户</h3>
      </div>
      <el-row class="tac">
        <el-menu
          class="el-menu-vertical-demo"
          style="border-right: none"
          router
          :default-active="$route.path"
        >
          <el-menu-item v-for="(r)  in routeData" :key="r.path" :index="r.path">
            <!-- <i :class="r.icon"></i> -->
            <span slot="title">{{ $t(r.name) }}</span>
          </el-menu-item>
        </el-menu>
      </el-row>
    </el-aside>
  </div>
</template>

<script>
export default {
  name: 'AsideBar',
  data() {
    return {
      // activitIndex: ''
    }
  },
  props: {
    routeData: Array
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.activitIndex = this.routeData[0].path
    //   this.$router.push(this.activitIndex).catch(err => {
    //     err.name = err.name + '' // ...
    //   })
    // })
  },
  methods: {
    changeSelect() {}
  }
}
</script>

<style scoped>
.subNav_Title {
  position: relative;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #e1e3e6;
  color: #222222;
  border-bottom: 1px solid #e1e3e6;
}
</style>
